import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedResidenceForecastApiService } from './residence-forecast-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ResidenceForecastApiService extends GeneratedResidenceForecastApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
